/** Jim Wanek — SiteGlue founder voice for blog articles. */

export const SITEGLUE_FOUNDER_PHOTO = "/siteglue/jim-wanek.png";

export const SITEGLUE_FOUNDER_PROFILE = {
  name: "Jim Wanek",
  role: "Founder of SiteGlue",
  aboutHref: "/about",
} as const;

/**
 * Default insight when an article does not supply `founderInsight`.
 * Stays aligned with Always a Human-in-the-Loop™ without interrupting reading.
 */
export const SITEGLUE_FOUNDER_DEFAULT_INSIGHT =
  "AI should make your team stronger — not smaller. SiteGlue is built so every conversation keeps judgment, empathy, and accountability with people: Always a Human-in-the-Loop™.";

/** Optional per-article override key in blog-posts.json (`founderInsight`). */
export function resolveFounderInsight(insight?: string | null): string {
  const trimmed = insight?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : SITEGLUE_FOUNDER_DEFAULT_INSIGHT;
}
